/**
 * L0 시작 화면 (시안 04 README 6장 L0 · 브랜드 BR1). 로그인하지 않은 사람의 첫 화면입니다.
 *
 * 골목 사진 전면 + 위 200px 먹색 55%→0, 아래 460px 0→90%(45% 지점부터). 아래에서 위로:
 * 버튼 둘(시작하기 · 이미 단골이에요) → 부제 「차 한 잔 내어 줄게, 쉬었다 가」 → 워드마크 40/48 → 크림 마크 52.
 * 사진 위라 주요 버튼은 팥 바탕이 아니라 크림 바탕 + 팥 글자입니다. 로그인한 사람은 이 화면을 건너뜁니다.
 *
 * 「시작하기」는 가입(L1b)으로 가고, 가입하면 첫 방문 골목(S0a)입니다. 소셜 로그인(L0b)은 키와 계정 연결 규칙이
 * 정해진 뒤 붙입니다(사용자 결정 2026-10-13).
 */
import { useNavigate } from 'react-router-dom';
import { WordmarkStack } from '../../components/Brand.jsx';
import { SceneBackdrop } from '../welcome/SceneCards.jsx';

export function StartPage() {
    const navigate = useNavigate();
    return (
        <SceneBackdrop image="alley" top={200} topOpacity={0.55} bottom={460} bottomOpacity={0.9} bottomFrom={45}>
            <main className="flex min-h-dvh flex-1 flex-col justify-end px-5 pb-8">
                <WordmarkStack
                    textSize={40}
                    lineHeight={48}
                    markSize={52}
                    tone="cream"
                    subtitle="차 한 잔 내어 줄게, 쉬었다 가"
                />
                <div className="mt-10 flex flex-col gap-3">
                    <button
                        type="button"
                        onClick={() => navigate('/login', { state: { mode: 'signup' } })}
                        className="h-[52px] w-full rounded-card bg-bg text-[16px] font-bold text-brand"
                    >
                        시작하기
                    </button>
                    <button
                        type="button"
                        onClick={() => navigate('/login', { state: { mode: 'login' } })}
                        className="h-[52px] w-full rounded-card border border-[rgba(246,241,231,0.6)] text-[16px] font-semibold text-bg"
                    >
                        이미 단골이에요
                    </button>
                </div>
            </main>
        </SceneBackdrop>
    );
}
